// extracted by mini-css-extract-plugin
export default {"paqueteContainer":"Paquete_paqueteContainer__8QDNj"};